// Third-party packages
import {
	createSlice,
	PayloadAction,
} from '@reduxjs/toolkit';

// Using a more flexible type that can accommodate all enum fields from the API
export interface OfferEnumsData {
	[key: string]: unknown;
}

export interface OfferEntryEnumsState {
	enums: OfferEnumsData | null;
	isError: boolean;
	isLoading: boolean;
}

export interface OffersEntryEnumsStore {
	[offerId: number]: OfferEntryEnumsState;
}

const initialState: OffersEntryEnumsStore = {};

export const offersEntryEnumsSlice = createSlice({
	initialState,
	name: 'offers_entry_enums',
	reducers: {
		setOfferEntryEnums: (state, action: PayloadAction<{
			enums: OfferEnumsData;
			offerId: number;
		}>) => {
			const {
				enums,
				offerId,
			} = action.payload;
			if (!state[offerId]) {
				state[offerId] = {
					enums: null,
					isError: false,
					isLoading: false,
				};
			}
			state[offerId].enums = enums;
		},
		setOfferEntryEnumsError: (state, action: PayloadAction<{
			isError: boolean;
			offerId: number;
		}>) => {
			const {
				isError,
				offerId,
			} = action.payload;
			if (!state[offerId]) {
				state[offerId] = {
					enums: null,
					isError: false,
					isLoading: false,
				};
			}
			state[offerId].isError = isError;
		},
		setOfferEntryEnumsLoading: (state, action: PayloadAction<{
			isLoading: boolean;
			offerId: number;
		}>) => {
			const {
				isLoading,
				offerId,
			} = action.payload;
			if (!state[offerId]) {
				state[offerId] = {
					enums: null,
					isError: false,
					isLoading: false,
				};
			}
			state[offerId].isLoading = isLoading;
		},
	},
});

export const {
	setOfferEntryEnums,
	setOfferEntryEnumsError,
	setOfferEntryEnumsLoading,
} = offersEntryEnumsSlice.actions;

export const offersEntryEnumsReducer = offersEntryEnumsSlice.reducer;
